export enum WantedStatus {
  publish,
  republish,
  unpublish
}
